<div
  [ngClass]="{
    'h-100': true,
    first: isFirst,
    last: isLast
  }"
>
  <div class="tab-btn-wrapper d-flex h-100">
    <button
      class="tab-btn btn btn-primary"
      (click)="tabClick.emit(tabKey)"
      [ngClass]="{
        active: isActive
      }"
    >
      <span>
        {{ tabText }}
      </span>
      <ng-content></ng-content>
    </button>
  </div>
</div>
